import PropTypes from 'prop-types'
import styled from 'styled-components'

import { Box, Play, Text, Link } from '@redriverpress/system'
import { routes } from '../../constants'

const Thumbnail = styled(Box).attrs({
  width: '80px',
  height: '52px',
  borderRadius: 'small',
})`
  background-image: url(${props => props.src});
  background-image: url(${props => props.src});
  background-size: cover;
  background-position: center;
`

const ThumbOverlay = styled(Box).attrs({
  width: '80px',
  height: '52px',
  borderRadius: 'small',
  bg: 'black',
})`
  position: absolute;
  opacity: 0.3;
`

const UpcomingVideoItem = styled(Box).attrs({
  display: 'flex',
  alignItems: 'flex-start',
  minHeight: '70px',
  borderRadius: 'small',
  p: 2,
  bg: 'white',
})`
  &:hover {
    .overlay,
    .playIcon {
      transition: opacity 0.1s;
      opacity: 0;
    }
  }
`

export default function UpcomingVideo({
  thumbnailUrl,
  title,
  videoSlug,
  subheading,
}) {
  return (
    <Link mb={3} href={`${routes.video}/${videoSlug}`} reset>
      <UpcomingVideoItem>
        <Box mr={2} display='flex' alignItems='center' justifyContent='center'>
          <ThumbOverlay className='overlay' />
          <Play
            className='playIcon'
            position='absolute'
            color='white'
            size='20px'
          />
          <Thumbnail src={thumbnailUrl} alt={title} />
        </Box>
        <Box display='flex' flexDirection='column'>
          <Text fontSize={0} fontWeight='600' textAlign='left'>
            {title}
          </Text>
          {
            <Text m={0} fontSize={0} textAlign='left'>
              {subheading}
            </Text>
          }
        </Box>
      </UpcomingVideoItem>
    </Link>
  )
}

UpcomingVideo.defaultProps = {
  thumbnailUrl: null,
  subheading: null,
}

UpcomingVideo.propTypes = {
  thumbnailUrl: PropTypes.string,
  title: PropTypes.string.isRequired,
  videoSlug: PropTypes.string.isRequired,
  subheading: PropTypes.string,
}
